import "../../styles/twickenhamPage.scss"

export const SeventhTwickenhamRoom = () => {
    return (
        <section className="seventh-tw-room photo-section">
            <div className="seventh-tw-room__wrapper">
                <img
                    style={{width: "53.9vw", height: "71.6vw"}}
                    className="seventh-tw-room__left opacity-animation-2s"
                    src="TwicknhamPage/TwickenhamSeventhRoomLeft.jpg"
                    alt="#"
                />

                <div className="seventh-tw-room__right">
                    <img
                        className="opacity-animation-2s"
                        style={{width: "22.65vw", height: "30.2vw"}}
                        src="TwicknhamPage/TwickenhamSeventhRoomRightTop.jpg"
                        alt="#"
                    />
                    <div className="seventh-tw-room__line opacity-animation-3s"></div>
                    <img
                        className="opacity-animation-2_5s"
                        style={{width: "22.65vw", height: "30.2vw"}}
                        src="TwicknhamPage/TwickenhamSeventhRoomRightBot.jpg"
                        alt="#"
                    />
                </div>
            </div>
        </section>
    )
}